import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getRenderable from '../../../lib/getRenderable';
import classes from './index.module.scss';

/**
 * @deprecated Please use Section from @fiverr-private/layout_components instead.
 */
const Section = ({
    children,
    className: customClassName,
    fluid,
    equalPadding
}) => {

    const className = classnames(
        classes.section,
        customClassName,
        {
            [classes.equalPadding]: equalPadding,
            [classes.fluid]: fluid
        }
    );

    return (
        <div className={className}>
            {getRenderable(children)}
        </div>
    );
};

Section.displayName = 'Section';

Section.propTypes = {
    /**
     * Any node that can be rendered.
     */
    children: PropTypes.node,
    /**
     * Whether or not the section has a fluid width
     * A fluid section has no max-width set.
     */
    fluid: PropTypes.bool,
    /**
     * Whether or not the section has equal paddings on all 4 sides.
     */
    equalPadding: PropTypes.bool,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: PropTypes.string
};

Section.defaultProps = {
    fluid: false,
    equalPadding: false
};

export default Section;
